import {store} from '@/store';
import type {DefaultMeta} from '@/types';

export default function getDefaultMeta(value: string): string | boolean | object | number | undefined {
    const meta: DefaultMeta = store.getters['company/defaultMeta'];

    const raw = meta[value];

    if ((raw === undefined || raw === null) && value === 'settings.payment.strategy') {
        return 'full';
    }

    return raw;
}


export function getMetaBooleanValue(value: string, trueIfMissing: boolean = false): boolean {
    const meta: DefaultMeta = store.getters['company/defaultMeta'];

    if (meta[value] === undefined || meta[value] === null) {
        return trueIfMissing;
    }

    // Handle string boolean values
    if (typeof meta[value] === 'string') {
        const lower = meta[value].toLowerCase();
        if (lower === 'false' || lower === '0' || lower === '') {
            return false;
        }
        if (lower === 'true' || lower === '1') {
            return true;
        }
    }

    return Boolean(meta[value]);
}